import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=f3a25000&scoped=true&"
import script from "./Exhibition.vue?vue&type=script&lang=js&"
export * from "./Exhibition.vue?vue&type=script&lang=js&"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=f3a25000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a25000",
  null
  
)

export default component.exports